import TweenMax  from 'gsap';
import colorLoop from "../Lib/helpers/colorLoop";

export default {
    namespaced: true,
    state: {
        rgb: {red: 0, green: 0, blue: 0},
        hsl: {hue: 0, saturation: 0, lightness: 0},
        hsv: {hue: 0, saturation: 0, value: 0},
        hex: {value: '#000000'},
    },
    mutations: {
        rgb(state, payload) {
            state.rgb = payload;
        },
        hsl(state, payload) {
            state.hsl = payload;
        },
        hsv(state, payload) {
            state.hsv = payload;
        },
        hex(state, payload) {
            state.hex = payload;
        },

        animateColorValues(state, {color, exclude}) {
            colorLoop(exclude,
                type => {
                    TweenMax.fromTo(state[type], .5, state.rgb, color[type]());
                }
            );
        }
    }
}